import Timer from 'react-compound-timer';
import React from 'react';
import Popup from "reactjs-popup";
import '../style.css'
import '../components/search.css'
import { Link,Redirect,withRouter} from "react-router-dom";
const axios = require('axios');
class Time extends React.Component
{
    constructor(props) {
        super(props);
        this.state = { 
          open: false,
          email:'',
          phno:'',
          webname:this.props.webname
         };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
      }
      openModal() {
        window.location="https://www.auctionsoftware.com/contact-us/"
      }
      closeModal() {
        this.setState({ open: false });
      }
      
  changeHandler = (event) => {
      let name = event.target.name;
      let value = event.target.value;
      this.setState({[name]:value});
  };
  handleSubmit = (event) => {
    console.log("++++++++++++++++++++++++++++++++")
  var apiBaseUrl = "http://localhost:3001/";  
  var payload={
    "email": this.state.email,
    "phno":this.state.phno,
    "webname":this.state.webname
    }
axios.post(apiBaseUrl, payload)
.then(function (response) {
  if(response.data="ok")
  {
   alert("email send sucessfully")
   window.location="/";
  }
  else
  {
    alert("email send sucessfully")
    console.log(response+"++++++++++");
  }
  }).catch(function (error) {
    console.log(error);
  });
}
 render(){
  const myStyle = {
    color: "white",
    backgroundColor: "DodgerBlue",
    padding: "10px",
    display:"flex",
    justifyContent: "center",
}
const myStyle1 = {
  color: "white",
  padding: "10px",
  display:"flex",
  justifyContent: "center",
}
const myStyle2 = {
  color: "block",
  backgroundColor: "orange",
  padding: "2px",
  display:"flex",
  float: 'right'
  
}
const myStyle3 = {
  display:"flex",
  justifyContent: "center",
}

return(

<div>
<Timer
initialTime={60000*5}
startImmediately={true}
direction="backward"
checkpoints={[
    {
        time:0,
        callback: () =>{this.openModal()},
    }
]}
>

{({ start, resume, pause, stop, reset, timerState }) => (

<React.Fragment>
   <button style={myStyle2}>
        Timer:&nbsp;&nbsp;
       <Timer.Minutes /> Minutes&nbsp;&nbsp;
       <Timer.Seconds /> Seconds&nbsp;&nbsp;&nbsp;&nbsp;
       
       <br></br>
   </button>
   <br />
</React.Fragment>
)}
</Timer>
 
 <Popup 
          open={this.state.open}
          closeOnDocumentClick
          onClose={this.closeModal}
        >
          <div>
            <p style={myStyle}>Pay Amount</p>
            <br/><br/><br/>
            {/* <form onSubmit={this.handleSubmit}>
            <div style={myStyle1}>
            <input type="text" style={myStyle1} value={this.state.email} name="email" placeholder="Enter your email" onChange={this.changeHandler} required/>
            </div>
            <br/><br/>
            <div style={myStyle1}>
            <input type="text" style={myStyle1} value={this.state.phno} name="phno" placeholder="Enter your phonenumber" onChange={this.changeHandler} required/>
            </div>
            <br></br><br></br> */}
          <div style={{float:"right"}}>
             <a href="https://www.auctionsoftware.com/contact-us/" target="_Blank"><button  style={{textAlign:"center"}} type="submit" className="orange-btn" >ContactUs</button></a>
             <br></br>
             <br></br>
             <Link  to={"/"} className="orange-btn ">Back</Link>
           </div>
           {/* </form> */}
             
           <br/><br/><br/><br/>
          </div>
        </Popup>
</div>);

}
}
export default withRouter(Time);